import Link from "next/link";
import ExternalLinkIcon from "@/components/core/icons/ExternalLinkIcon";
import { stripTrackingParams } from "@/helpers/stripTrackingParams";

export default function LinkMark({
  removeTrackingParams,
  value,
  href: directHref,
  external,
  children,
}: any) {
  const link = value ?? { href: directHref, isExternal: external };
  if (link.href === undefined) return children;

  let href = link.href;
  if (removeTrackingParams) {
    href = stripTrackingParams(href)
  }
  const isExternal =
    link.isExternal ||
    ((href?.startsWith("http://") || href?.startsWith("https://")) &&
      !href?.includes("https://www.dash0.com"));

   const Component = isExternal ? "a" : Link;

  return (
    <Component
      href={href}
      target={isExternal ? "_blank" : "_self"}
      className="underline underline-offset-2 hover:no-underline hover:text-red-500 max-md:break-all"
    >
      {children}
      <span className={isExternal ? "external-link" : "hidden"}>
        <ExternalLinkIcon />
      </span>
    </Component>
  );
}
